import { useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ProductCard from "../../../components/product/ProductCard";
import Breadcrumbs from "../../../components/section/BreadCrumbs";

const Container = styled.article`
  color: ${(props) => props.theme.textColor};
`;
const Section = styled.section`
  width: 100%;
  @media (min-width: 1025px) {
    max-width: var(--max-width-container);
  }
`;
const MarginDiv = styled.div`
  width: 96%;
  margin: 0 auto;
`;
const Title = styled.h1`
  font-size: var(--font-size-xxlarge);
`;
const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;

  @media (min-width: 768px) and (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }

  @media (min-width: 1025px) {
    grid-template-columns: repeat(5, 1fr);
    gap: 12px;
  }
`;
const EmptyContainer = styled.div`
  height: 30vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const EmptyText = styled.p`
  color: var(--p-color);
  font-size: var(--font-size-base);
`;

const SavedProductsMain = () => {
  const { t } = useTranslation();
  const saveForLaterItems = useSelector(
    (state) => state.saveForLater.itemsList
  );
  const [openIndex, setOpenIndex] = useState(null);
  const handleSetOpenIndex = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const breadcrumbItems = [
    { name: "SnusCo", url: "/" },
    { name: t("CART.SAVED_FOR_LATER"), url: "/" },
  ];

  return (
    <Container>
      <Section className="header-top-margin">
        <MarginDiv>
          <Breadcrumbs breadcrumbs={breadcrumbItems} />
          <Title>{t("CART.SAVED_FOR_LATER")}</Title>
        </MarginDiv>

        {saveForLaterItems.length === 0 ? (
          <EmptyContainer>
            <EmptyText>{t("CART.SAVED_FOR_LATER_EMPTY")}</EmptyText>
          </EmptyContainer>
        ) : (
          <ProductGrid>
            {saveForLaterItems.map((item, index) => (
              <ProductCard
                key={index}
                product={item.product}
                isOpen={openIndex === index}
                setIsOpen={() => handleSetOpenIndex(index)}
              />
            ))}
          </ProductGrid>
        )}
      </Section>
    </Container>
  );
};

export default SavedProductsMain;
